import { formComponents } from "@onlinesales-ai/form-components-v2";
import ImageUploader from "../../mediaLibraryFormComponent";

export default {
  ...formComponents,
  ImageUploader,
};
